import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';

import {HomeRoutingModule} from './home-routing.module';
import {HomeComponent} from './home.component';

import {ChartsModule} from 'ng2-charts';
import {HomeService} from './services/home.service';
import {HomeRepository} from './repositories/home.repository';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HomeRoutingModule,
    ChartsModule,
  ],
  declarations: [
    HomeComponent,
  ],
  providers: [
    HomeService,
    HomeRepository,
  ],
})

export class HomeModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/home/home.module.ts